import React, { useContext, useEffect } from "react";
import { Box } from "@mui/material";
import AppContext from "../../../context/appContext";
import { ContentAttachmentsResults } from "../../../components/ContentListAttachments/ContentListAttachments";
import ContentRow from "../ContentRow/ContentRow";
import AttachmentRow from "../AttachmentRow/AttachmentRow";
import ContentActivityFooter from "../NewActivity/ContentActivityFooter/ContentActivityFooter";
import NoResultsFiles from "../../../components/NoResultsFiles/NoResultsFiles";
import { countSelectedAttachments } from "../../../utils";
import { getSoapOperaScheduleLabel } from "../../../shared/constants/soapOperaSchedule";

const FilterProjectResult = (props) => {
  const {
    currentProject,
    files,
    showList,
    onSelectionChange,
    isDisabled,
    hasGlobalSelection,
    clearSelectionsTrigger,
    clearActive,
    toggleActiveCheckBox,
    toggleActiveVersionCheckBox,
  } = props;

  const appContext = useContext(AppContext);

  const handleToggleActiveCheckBox = (file, index) => {
    if (isDisabled) return;
    toggleActiveCheckBox(file, index);
  };

  const handleToggleActiveVersionCheckBox = (item, index, versionIndex) => {
    if (isDisabled) return;
    toggleActiveVersionCheckBox(item, index, versionIndex);
  };

  useEffect(() => {
    if (clearSelectionsTrigger > 0) clearActive();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearSelectionsTrigger]);

  const createIsValid = () => {
    const hasVersions = currentProject.type !== "Research";
    const parentIsValid =
      !!files.length && files.some((item) => !!item.parent?.isActive);
    const versionIsValid = hasVersions
      ? !!files.length &&
        files.some(
          (item) => !!item.version.some((version) => !!version.isActive)
        )
      : hasVersions;

    return parentIsValid || versionIsValid;
  };

  useEffect(() => {
    if (!Array.isArray(files) || !onSelectionChange || !currentProject) return;
    const hasAnyActive = files.some(
      (item) => item.parent?.isActive || item.version?.some((v) => v?.isActive)
    );
    const step =
      currentProject.type !== "Research"
        ? "createProjectActivity"
        : "createResearchActivity";
    onSelectionChange(
      hasAnyActive,
      createIsValid(),
      step,
      countSelectedAttachments(files)
    );
    // eslint-disable-next-line
  }, [files]);

  if (!currentProject || !showList) return <></>;

  const isResearch = currentProject.type === "Research";
  const formatName = currentProject.format?.name;

  // researchCategory/researchSubCategory come from the attachments endpoint, not ContentSearch.
  const detailsText = isResearch
    ? [currentProject.researchCategory, currentProject.researchSubCategory]
        .filter(Boolean)
        .join(" • ")
    : [
        formatName,
        formatName === "Novela"
          ? getSoapOperaScheduleLabel(currentProject.soapOperaSchedule)
          : null,
      ]
        .filter(Boolean)
        .join(" • ");

  const lastAttachmentText = currentProject.lastAttachmentReceivedDate
    ? appContext.formatDate(
        appContext.convertDatePtBr(currentProject.lastAttachmentReceivedDate)
      )
    : "-";

  const sheetLink = appContext.redirectToSheet(
    currentProject.type,
    currentProject.id
  );

  const peopleNames = isResearch
    ? currentProject.researchers.map((r) => r.name)
    : currentProject.creators.map((c) => c.name);

  const visibleFiles = files.filter(
    (file) => file?.parent?.fileId && file?.parent?.fileName
  );

  return (
    <ContentAttachmentsResults
      results={[currentProject]}
      renderResult={() => (
        <ContentRow
          key={currentProject.id}
          iconType={currentProject.type}
          title={currentProject.title}
          people={peopleNames}
          detailsText={detailsText}
          origins={currentProject.origins ?? []}
          lastAttachmentText={lastAttachmentText}
          sheetLink={sheetLink}
          alwaysOpen
          disabled={isDisabled}
        >
            <Box className="attachmentsList">
              <Box component="ul" className="attachmentsHeader">
                <Box component="li" className="type">
                  Tipo
                </Box>
                <Box component="li" className="version">
                  Versão
                </Box>
                <Box component="li" className="file">
                  Arquivo
                </Box>
                <Box component="li" className="receivedAt">
                  Recebido Em
                </Box>
                <Box component="li" />
              </Box>

              {files.length > 0 ? (
                visibleFiles.map((file, index) => (
                  <AttachmentRow
                    key={index}
                    file={file}
                    index={index}
                    format={formatName}
                    onToggleParent={handleToggleActiveCheckBox}
                    onToggleVersion={handleToggleActiveVersionCheckBox}
                  />
                ))
              ) : (
                <NoResultsFiles redirectToSheet={() => sheetLink} />
              )}
            </Box>

            {!hasGlobalSelection && (
              <ContentActivityFooter
                isValid={createIsValid()}
                selectedCount={countSelectedAttachments(files)}
                onCreateActivity={() =>
                  appContext.setCurrentStepBox(
                    isResearch
                      ? "createResearchActivity"
                      : "createProjectActivity"
                  )
                }
                onCancel={clearActive}
              />
            )}
          </ContentRow>
        )}
      />
  );
};

export default React.memo(FilterProjectResult);
